var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "margin-bottom-lg" }, [
    _c(
      "div",
      { staticClass: "row align-stretch" },
      _vm._l(_vm.features, function (feature) {
        return _c(
          "div",
          { key: feature.id, class: _vm.featureClass },
          [
            _c(
              feature.location.href ? "a" : "site-link",
              _vm._b(
                {
                  tag: "component",
                  class: _vm.setFeatureCardClass(feature.theme),
                  staticStyle: {
                    "--card-link-box-shadow-color":
                      "var(--card-link-hover-border-color)",
                    height: "100%",
                  },
                  on: {
                    click: function ($event) {
                      return _vm.handleFeatureClick(feature)
                    },
                  },
                },
                "component",
                _vm.getLocationProps(feature),
                false
              ),
              [
                _c(
                  "div",
                  {
                    staticClass: "header padding-0 position-relative",
                    staticStyle: {
                      "min-height": "var(--feature-image-min-height, 15rem)",
                      overflow: "hidden",
                    },
                  },
                  [
                    _c("img", {
                      staticStyle: {
                        width: "100%",
                        height: "100%",
                        "object-fit": "cover",
                        "object-position": "center",
                        display: "block",
                      },
                      attrs: {
                        src: `/images/icons/features/${feature.image}`,
                        alt: "",
                        "aria-hidden": "",
                      },
                    }),
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "header",
                    staticStyle: {
                      "--card-header-border": "none",
                      flex: "1 0 auto",
                    },
                  },
                  [
                    _c(
                      "h3",
                      {
                        staticClass: "h5 margin-bottom-md text-uppercase",
                        staticStyle: {
                          "letter-spacing": "var(--letter-spacing-2xl)",
                        },
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(feature.title) +
                            "\n          "
                        ),
                      ]
                    ),
                    _vm._v(" "),
                    _c("p", [_vm._v(_vm._s(feature.description))]),
                  ]
                ),
              ]
            ),
          ],
          1
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }